<div class="header-dots">
  <div
    class="input-group"
    placement="bottom"
    *ngxPermissionsOnly="['bulkAdd']"
    [ngbTooltip]="((selectedLocation$ | async).id) ? '' : 'Select a location'"
  >
    <button
      type="button"
      id="header-quickSend" 
      class="btn btn-primary ms-4"
      [hidden]="!((selectedLocation$ | async).id)"
      (click)="navigateTo('/admin-location/send')"
    >
      <icon-plane></icon-plane>
      <span class="d-none d-sm-inline">Send</span>
    </button>
  </div>

  <!-- translate button hidden -->
  <div
    *ngxPermissionsOnly="['changeLanguage']"
    ngbDropdown
    class="input-group"
    placement="bottom"
    [hidden]="true"
  >
    <button type="button" class="btn btn-link p-0 mr-2" ngbDropdownToggle>
      <span>
        <div class="icon-wrapper icon-wrapper-alt rounded-circle">
          <div class="icon-wrapper-bg bg-focus"></div>
          <img class="flag-ppal" src="./assets/images/us-flag.png">
        </div>
      </span>
    </button>

    <div ngbDropdownMenu>
      <div class="dropdown-menu-header">
        <div class="dropdown-menu-header-inner pt-4 pb-4 bg-focus">
          <div class="menu-header-image opacity-05 dd-header-bg-4"></div>
          <div class="menu-header-content text-center text-white">
            <h6 class="menu-header-subtitle mt-0">Choose Language</h6>
          </div>
        </div>
      </div>
      <h6 class="dropdown-header">Languages</h6>
      <button type="button" class="dropdown-item">
        <img class="f-icons" src="./assets/images/us-flag.png">
        <span>English</span>
      </button>
      <button type="button" class="dropdown-item">
        <img class="f-icons" src="./assets/images/spain-flag.png">
        <span>Spanish</span>
      </button>
      <button type="button" class="dropdown-item">
        <img class="f-icons" src="./assets/images/france-flag.png">
        <span>French</span>
      </button>
      <button type="button" class="dropdown-item">
        <img class="f-icons" src="./assets/images/german-flag.png">
        <span>German</span>
      </button>
    </div>
  </div>
</div>
